var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNenhumaacomodacao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 611.6 440.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #6543fa;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-6 {\n        stroke-width: 4.11px;\n      }\n\n      .cls-2, .cls-7, .cls-3, .cls-4, .cls-5, .cls-8, .cls-6 {\n        stroke: #2d2165;\n      }\n\n      .cls-2, .cls-6 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-9 {\n        fill: #6543fa;\n      }\n\n      .cls-7, .cls-5 {\n        stroke-width: 10.27px;\n      }\n\n      .cls-7, .cls-10 {\n        fill: #2d2165;\n      }\n\n      .cls-11, .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        stroke-width: 8.22px;\n      }\n\n      .cls-12 {\n        fill: #7041ff;\n      }\n\n      .cls-8 {\n        fill: #10101d;\n        stroke-width: 14.38px;\n      }\n\n      .cls-13 {\n        fill: #94d8f4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M514.12,321.21c7.8,0,14.12-6.32,14.12-14.12V15.09c0-7.2-4.98-13.03-11.12-13.03H13.17C7.03,2.05,2.05,7.89,2.05,15.09v292.01c0,7.8,6.32,14.12,14.12,14.12h497.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.34,31.47c0,3.93-3.18,7.11-7.11,7.11s-7.11-3.18-7.11-7.11,3.19-7.11,7.11-7.11,7.11,3.19,7.11,7.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M62.24,31.47c0,3.93-3.19,7.11-7.11,7.11s-7.11-3.18-7.11-7.11,3.18-7.11,7.11-7.11,7.11,3.19,7.11,7.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M83.12,31.47c0,3.93-3.18,7.11-7.11,7.11s-7.11-3.18-7.11-7.11,3.19-7.11,7.11-7.11,7.11,3.19,7.11,7.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M427.2,31.47c0,5.45-4.41,9.86-9.86,9.86s-9.87-4.42-9.87-9.86,4.42-9.86,9.87-9.86,9.86,4.42,9.86,9.86Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "422.13 29.04 417.27 33.91 412.41 29.04"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 449.86,
    y1: 23.32,
    x2: 449.86,
    y2: 39.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 458.01,
    y1: 31.48,
    x2: 441.71,
    y2: 31.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "479.82 22.8 473.2 22.8 473.2 29.42 479.82 29.42 479.82 22.8 479.82 22.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "479.82 33.53 473.2 33.53 473.2 40.15 479.82 40.15 479.82 33.53 479.82 33.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "490.64 22.8 484.02 22.8 484.02 29.42 490.64 29.42 490.64 22.8 490.64 22.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "490.64 33.53 484.02 33.53 484.02 40.15 490.64 40.15 490.64 33.53 490.64 33.53"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M390.97,170.13h-254.38c-10.98,0-19.87-8.9-19.87-19.87h0c0-10.98,8.9-19.87,19.87-19.87h254.38c10.98,0,19.87,8.9,19.87,19.87h0c0,10.98-8.9,19.87-19.87,19.87Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 138.28,
    cy: 131.56,
    rx: 92.16,
    ry: 64.01,
    transform: "translate(-42.38 193.12) rotate(-62.39)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 134.37,
    cy: 129.51,
    rx: 92.16,
    ry: 59.59,
    transform: "translate(-42.67 188.55) rotate(-62.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.71,292.33l26.65-54.67-19.52-9.44-26.62,54.61c-2.63,5.39-.38,11.9,5.02,14.51h0c5.38,2.6,11.85.36,14.47-5.01Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 79.98,
    y1: 230.08,
    x2: 88.33,
    y2: 212.83
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 544.06,
    cy: 355.9,
    rx: 88.21,
    ry: 31.5,
    transform: "translate(-95.5 472.65) rotate(-43.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M331.81,191.67c.02-.07.04-.13.05-.2l17.83-39.69c.22-1,12.06-14.55,12.93-15.08l21.68-19.07c20.69-12.33,45.33-17.75,69.39-15.26l8.74.9c.14.02.29.05.43.07,28.73,6.19,53.59,25.71,66.52,52.22l74.5,150.25c.74,1.55-1.11,4.6-1.19,4.66,0,0-6.97,14.85-24.08,29.85-35.7,31.3-62.11,29.21-62.47,28.06l-54.02-153.66-59.14,4.21-24.09,10.1c-5.6,1.19-11.01-1.3-13.77-6.34-2.79-5.08-1.97-11.01,2.1-15.1,2.14-2.15,4.62-3.99,7.36-5.46,11.2-5.97,30.6-17.24,35.76-21.45-.54-.67-4.23-5.52-4.68-6.28l-4.02-18.24c-.63-1.07,2.76-10.65,3.24-11.73l-22.6,7.87-5.12,5.18c-7.96,8.04-14.38,17.51-18.59,28.02-3.22,8.02-7.61,16.12-12.42,17.41-3.49.94-7.32.47-10.16-1.76-2.92-2.29-4.46-5.81-4.15-9.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M410.31,179.82s-19.95,16.77-34.34,24.48c-2.61,1.4-4.78,3.07-6.57,4.88-6.36,6.4-.58,17.14,8.24,15.24l27.08-5.84,58.52-3.88,52.64,153.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M604.99,309.48l-77.31-154.65c-12.55-25.87-36.36-44.49-64.5-50.43l-8.84-.88c-23.71-2.35-47.55,2.98-68,15.2l-7.98,4.77c-21.01,12.56-35.94,33.19-41.29,57.07l-2.38,10.6c-.23,4.65,4.01,8.26,8.57,7.3h0c7.34-1.56,13.2-7.08,15.18-14.32l6.36-23.19,44.8-21.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.95,121.7l-18.56,18.96c-7.57,7.73-9,19.58-3.49,28.9l2.85,4.82c2.17,3.67,5.89,6.17,10.11,6.78h0c5.14.75,10.28-1.38,13.38-5.56l.38-.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M448.51,124.64l-16.65,18.01c-7.02,7.59-8.22,18.88-2.96,27.78l2.62,4.43c2.61,4.42,7.09,7.42,12.17,8.17h0c4.33.63,8.67-1.08,11.4-4.5l3.62-4.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M469.32,132.41l-15.03,18.64c-2.84,3.06-3.33,7.62-1.2,11.21l7.09,11.99c3.13,5.29,8.48,8.88,14.56,9.77h0c3.4.5,6.84-.64,9.28-3.07l7-6.99c2.87-2.87,3.59-7.25,1.78-10.88l-.02-.03c-2.72-5.46-9.84-6.94-14.51-3.01h0"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 136.91,
    y1: 150.36,
    x2: 282.46,
    y2: 150.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M138.27,80.81c-11.97,0-21.68,8.83-21.68,19.71s21.68,40.74,21.68,40.74c0,0,21.68-29.85,21.68-40.74s-9.71-19.71-21.68-19.71ZM138.27,108.41c-4.79,0-8.67-3.53-8.67-7.89s3.88-7.89,8.67-7.89,8.67,3.53,8.67,7.89-3.88,7.89-8.67,7.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M429.54,249.91c-5.46-1.8-11.24-2.45-16.96-1.9l-149.67,14.25c-5.72.54-11.27,2.26-16.3,5.06-14.51,8.06-22.88,23.95-21.32,40.47l5.54,58.2c.44,4.59,4.51,7.96,9.11,7.52,4.59-.44,7.96-4.51,7.52-9.11l-.4-4.16c-.19-2.29,1.48-4.31,3.76-4.55l191.24-18.21c2.29-.19,4.31,1.48,4.55,3.76l.4,4.16c.44,4.59,4.51,7.96,9.11,7.52s7.96-4.51,7.52-9.11l-5.54-58.2c-1.59-16.52-12.8-30.54-28.57-35.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M392.98,174.36l-124.72,11.87c-16.07,1.53-27.86,15.8-26.33,31.87l3.56,37.42c.11,1.15,1.13,1.99,2.28,1.88.19-.02.39-.06.57-.14,4.41-1.76,9.05-2.88,13.78-3.33l2.2-.21c1.06-.09,1.88-.98,1.9-2.04.14-8.5,6.64-15.54,15.1-16.36l29.1-2.77c8.47-.81,16.19,4.88,17.93,13.21.22,1.04,1.19,1.75,2.25,1.65l12.71-1.21c1.06-.09,1.88-.98,1.9-2.04.14-8.5,6.63-15.53,15.09-16.36l29.1-2.77c8.47-.81,16.19,4.88,17.93,13.21.22,1.04,1.19,1.75,2.25,1.65l2.18-.21c4.73-.45,9.5-.23,14.16.67,1.13.21,2.23-.53,2.44-1.67.04-.19.05-.39.03-.59l-3.56-37.42c-1.53-16.07-15.8-27.86-31.87-26.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M386.34,118.73l-8.59,5.13c-20.62,12.33-35.27,32.58-40.53,56.02l-2.53,11.28c-.23,4.65,4.01,8.26,8.57,7.3h0c7.34-1.56,13.2-7.08,15.18-14.32h0c4.04-14.72,14.3-26.95,28.1-33.47l20.38-9.35"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 209.29,
    cy: 351.8,
    r: 88.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M227.67,329.43l-17.25,13.39-13.39-17.25c-2.17-2.79-6.19-3.3-8.98-1.13s-3.3,6.19-1.13,8.98l13.39,17.25-17.25,13.39c-2.79,2.17-3.29,6.19-1.12,8.98,2.17,2.79,6.18,3.29,8.97,1.13l17.25-13.39,13.39,17.25c2.17,2.79,6.19,3.29,8.98,1.12,2.79-2.17,3.29-6.18,1.13-8.97l-13.39-17.25,17.25-13.39c2.79-2.17,3.3-6.19,1.13-8.98s-6.19-3.3-8.98-1.13h0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNenhumaacomodacao);
export default __webpack_public_path__ + "static/media/Nenhuma acomodacao.3f231a97853f63304bb98364f697b90b.svg";
export { ForwardRef as ReactComponent };